import {UserAdmission, ObjectType} from '@oc/user-management'
import {UserPermissionsState} from '../UserPermissionsContext'

export function createAdmission(
    action: string,
    resource: string,
    objectType?: ObjectType | null,
    objectName?: string | null
): UserAdmission {
    return {
        action: action,
        resource: resource,
        objectType: objectType || null,
        objectName: objectName || null
    }
}

export const routesMapping = {
    withCustomerOnly: {
        customerEdit: {
            path: '/edit'
        },
        viewCustomer: {
            path: '/view-customer'
        },
        equipmentManagement: {
            path: '/equipment'
        },
        viewEquipment: {
            path: '/view-equipment'
        },
        timestealerConfiguration: {
            path: '/timestealer'
        },
        accountRkMonitoring: {
            path: '/monitoring'
        },
        insight: {
            path: '/insight'
        },
        fleetManagement: {
            path: '/fleet-management'
        }
    },
    withCustomerAndRk: {
        network: {
            path: '/network'
        },
        hwAndServices: {
            path: '/hw-and-services'
        },
        deploy: {
            path: '/deploy'
        },
        registerRk: {
            path: '/register-rk'
        },
        passwords: {
            path: '/passwords'
        },
        meda: {
            path: '/meda'
        },
        interfaces: {
            path: '/interfaces'
        },
        rkConfig: {
            path: '/rk-config'
        },
        rkMonitoring: {
            path: '/monitoring/'
        },
        rkSystemInformation: {
            path: '/rk-system-information'
        },
        rkLogs: {
            path: '/log-upload/'
        },
        restartService: {
            path: '/restart-service/'
        },
        dasValidation: {
            path: '/das-validation/'
        },
        dasValidationAdapterValues: {
            path: '/das-validation/adapter-values/:sourceId'
        },
        rkMonitoringConfiguration: {
            path: '/monitoring-configuration/'
        },
        ntpValidation: {
            path: '/ntp-diagnostic/'
        },
        connectivityCheck: {
            path: '/connectivity-check/'
        },
        decommissioning: {
            path: '/decommissioning'
        },
        rkSsm: {
            path: '/rk-ssm'
        },
        dataValidation: {
            path: '/data-validation'
        },
        onboarding: {
            path: '/onboarding'
        },
        kopVersionControl: {
            path: '/kop-version-control'
        },
        opcuaMapping: {
            path: '/opcua-mapping'
        },
        localFlashFluidFiles: {
            path: '/flash-fluid-files'
        }
    },
    allOther: {
        dashboard: {
            path: '/'
        },
        dashboardV1: {
            path: '/dashboard-v1'
        },
        audit: {
            path: '/audit'
        },
        globalSettings: {
            path: '/view-global-settings'
        },
        userManagement: {
            path: '/user-management'
        },
        userManagementSettings: {
            path: '/user-management/settings'
        },
        addCustomer: {
            path: '/add-customer'
        },
        logout: {
            path: '/logout'
        },
        globalRkMonitoring: {
            path: '/rk-monitoring'
        },
        zaitGlobalSettings: {
            path: '/zait-global-settings'
        },
        massDeploy: {
            path: '/mass-deploy'
        },
        uxLab: {
            path: '/ux-lab'
        }
    }
}

export interface Routes {
    allOther: {
        dashboard: Route
        dashboardV1: Route
        audit: Route
        globalSettings: Route
        userManagement: Route
        userManagementSettings: Route
        addCustomer: Route
        logout: Route
        globalRkMonitoring: Route
        massDeploy: Route
        uxLab: Route
    }
    withCustomerOnly: {
        customerEdit: Route
        viewCustomer: Route
        equipmentManagement: Route
        viewEquipment: Route
        timestealerConfiguration: Route
        accountRkMonitoring: Route
        insight: Route
        localFlashFluidFiles: Route
        fleetManagement: Route
    }
    withCustomerAndRk: {
        network: Route
        hwAndServices: Route
        deploy: Route
        decommissioning: Route
        registerRk: Route
        passwords: Route
        meda: Route
        interfaces: Route
        rkConfig: Route
        rkMonitoring: Route
        rkSystemInformation: Route
        rkLogs: Route
        restartService: Route
        dasValidation: Route
        dasValidationAdapterValues: Route
        rkMonitoringConfiguration: Route
        ntpValidation: Route
        connectivityCheck: Route
        rkSsm: Route
        dataValidation: Route
        onboarding: Route
        kopVersionControl: Route
        opcuaMapping: Route
    }
}

export interface Route {
    admission?: UserAdmission
    admissionOr?: UserAdmission[]
    admissionAnd?: UserAdmission[]
    customCheck?: (userPermissions: UserPermissionsState, customerId?: string) => boolean
    path: string
    module: React.ComponentType
}
